import React, { useCallback, useState } from 'react';
import EditorLink from '@wix/da-ds/pkg/Icons/24x24/EditorLink';
import { useTranslation } from 'react-i18next';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import EditorIconButton from '../../../../../components/menus/_partials/EditorIconButton';
import { TOOLTIP_HOVER_DELAY } from '../../../../../constants';
import cn from 'classnames';
import TextInput from '@wix/da-ds/pkg/formControls/lego/InputField';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { addMissingProtocol, validateHref } from '../../../../../components/utils/validateHref';
import { getCurrentUser } from '../../../../../components/utils/tiptap';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import Close from '@wix/da-ds/pkg/Icons/24x24/Close';
import { isTouch } from '../../../../../components/utils/browser';
import s from './Link.scss';
const offsetModifier = [
    0,
    6
];
const Link = ({ editor })=>{
    var _attrs_deviation_author, _attrs_deviation;
    const attrs = editor.getAttributes('da-deviation');
    const { t } = useTranslation('editor');
    const [open, setOpen] = useState(false);
    var _attrs_link;
    const [href, setHref] = useState((_attrs_link = attrs.link) !== null && _attrs_link !== void 0 ? _attrs_link : '');
    const [valid, setValid] = useState(true);
    const currentUser = getCurrentUser(editor);
    const allowLink = (attrs === null || attrs === void 0 ? void 0 : (_attrs_deviation = attrs.deviation) === null || _attrs_deviation === void 0 ? void 0 : (_attrs_deviation_author = _attrs_deviation.author) === null || _attrs_deviation_author === void 0 ? void 0 : _attrs_deviation_author.userId) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId);
    const handleSave = useCallback((e)=>{
        if (validateHref(addMissingProtocol(href)) || href === '') {
            editor.commands.updateAttributes('da-deviation', {
                link: href === '' ? null : addMissingProtocol(href)
            });
            setOpen(false);
        }
    }, [
        editor.commands,
        href
    ]);
    const handleChange = useCallback((e)=>{
        setHref(e.target.value.trim());
        setValid(validateHref(addMissingProtocol(e.target.value.trim())));
    }, []);
    return /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        popoverContent: /*#__PURE__*/ React.createElement("div", {
            className: cn(s['root'], 'ds-surface-tertiary')
        }, /*#__PURE__*/ React.createElement(TextInput, {
            id: "link",
            value: href,
            onChange: handleChange,
            validationResult: !valid ? 'error' : 'success',
            placeholder: t('ext.deviation.settings.link.noanchor.placeholder'),
            postfix: /*#__PURE__*/ React.createElement(IconButton, {
                icon: Close,
                "aria-label": t('common.close'),
                size: "small",
                onClick: ()=>{
                    setHref('');
                    setValid(true);
                }
            }),
            onFocus: (e)=>{
                setTimeout(()=>{
                    isTouch() && e.target.scrollIntoView();
                }, 300);
            }
        }), /*#__PURE__*/ React.createElement(BrandedButton, {
            onClick: handleSave,
            size: "medium",
            variant: "brand-green"
        }, "Save")),
        placement: "bottom",
        isVisible: open,
        offsetModifier: offsetModifier,
        onClickOutside: ()=>{
            setOpen(false);
        }
    }, /*#__PURE__*/ React.createElement(EditorIconButton, {
        disabled: !allowLink,
        icon: EditorLink,
        onClick: ()=>{
            setOpen(!open);
        },
        tooltipHoverDelay: TOOLTIP_HOVER_DELAY,
        tooltipText: t('ext.deviation.settings.link.label'),
        "aria-label": t('ext.deviation.settings.link.label')
    }));
};
Link.displayName = 'Link';
export default Link;

//# sourceMappingURL=Link.js.map